import { type SVGProps } from 'react'

export function CopyIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#475467'

  return (
    <svg fill="none" height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16699 13C3.39042 13 3.00214 13 2.69585 12.8731C2.28747 12.704 1.96302 12.3795 1.79386 11.9711C1.66699 11.6648 1.66699 11.2766 1.66699 10.5V4.83332C1.66699 3.8999 1.66699 3.43319 1.84865 3.07667C2.00844 2.76307 2.2634 2.5081 2.57701 2.34831C2.93353 2.16666 3.40024 2.16666 4.33366 2.16666H10.0003C10.7769 2.16666 11.1652 2.16666 11.4715 2.29352C11.8798 2.46268 12.2043 2.78714 12.3735 3.19552C12.5003 3.5018 12.5003 3.89009 12.5003 4.66666M10.167 18.8333H15.667C16.6004 18.8333 17.0671 18.8333 17.4236 18.6517C17.7372 18.4919 17.9922 18.2369 18.152 17.9233C18.3337 17.5668 18.3337 17.1001 18.3337 16.1667V10.6667C18.3337 9.73324 18.3337 9.26653 18.152 8.91001C17.9922 8.5964 17.7372 8.34143 17.4236 8.18165C17.0671 7.99999 16.6004 7.99999 15.667 7.99999H10.167C9.23357 7.99999 8.76686 7.99999 8.41034 8.18165C8.09674 8.34143 7.84177 8.5964 7.68198 8.91001C7.50033 9.26653 7.50033 9.73324 7.50033 10.6667V16.1667C7.50033 17.1001 7.50033 17.5668 7.68198 17.9233C7.84177 18.2369 8.09674 18.4919 8.41034 18.6517C8.76686 18.8333 9.23357 18.8333 10.167 18.8333Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  )
}
